import(/* webpackMode: "eager", webpackExports: ["BookingClient"] */ "/vercel/path0/apps/scheduler-app/src/app/[slug]/BookingClient.tsx");
